export default "__VITE_ASSET__675b5a80__"